import { useEffect } from 'react';

/**
 * Nie pozwala wygasić ekranu, póki trwają zakupy. Po powrocie do karty blokada jest odnawiana
 * (przeglądarka zwalnia ją przy ukryciu strony). Błędy ignorujemy — tryb oszczędzania energii albo brak wsparcia.
 */
export function useWakeLock(active: boolean): void {
  useEffect(() => {
    if (!active || !('wakeLock' in navigator)) return;
    let sentinel: WakeLockSentinel | null = null;
    let requesting = false;
    let disposed = false;

    const acquire = async () => {
      if (disposed || requesting || document.visibilityState !== 'visible') return;
      if (sentinel && !sentinel.released) return;
      requesting = true;
      try {
        const s = await navigator.wakeLock.request('screen');
        if (disposed) void s.release().catch(() => {});
        else sentinel = s;
      } catch {
        // brak zgody / oszczędzanie energii
      } finally {
        requesting = false;
      }
    };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') void acquire();
    };

    void acquire();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      disposed = true;
      document.removeEventListener('visibilitychange', onVisibility);
      void sentinel?.release().catch(() => {});
      sentinel = null;
    };
  }, [active]);
}
